import { computed, ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

export enum FeatureToggles {
  EXAMPLE_TOGGLE = 'exampleToggle', // example feature toggle, please don't remove
  SKIP_PROPERTY_OWNERSHIP = 'skipPropertyOwnership', // Skip property ownership step in valuation flow
  PP_3365_HOW_LP_NEW_HERO_SECTION = 'PP-3365_how-lp-new-hero-section', // New My Properties Hero Section design with House/Apartment CTAs
}

export const DEFAULT_FEATURES_VALUE: Record<FeatureToggles, boolean> = {
  [FeatureToggles.EXAMPLE_TOGGLE]: false,
  [FeatureToggles.SKIP_PROPERTY_OWNERSHIP]: true, // Default to true - skip PropertyOwnership step by default
  [FeatureToggles.PP_3365_HOW_LP_NEW_HERO_SECTION]: false,
};

const useFeatureToggle = (toggle: FeatureToggles): ComputedRef<boolean> => {
  const route = useRoute();

  return computed(() => {
    return route.query[toggle] === 'true' || DEFAULT_FEATURES_VALUE[toggle];
  });
};

export default useFeatureToggle;
